<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Accelerating and improving research process for Africa-focused Investors</h2>
    <p>Asoko provides an on-demand suite of services to support market sizing, buy-and-build strategies, competitive analysis and exit-planning. Services include market mapping, stakeholder mapping, investor mapping and historical deal analysis</p>
    <div class="action-wrap">
      <a @click="openSolutions" class="cta-button" :class="colorMode === 'light' ? 'medium-button' : ''">Learn More</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'investor-research-conversion',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openSolutions() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'Investor Research Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'Investor Research Block',
      })
      this.$router.push({ name: 'solutions-page' })
    },
  },
}
</script>
